export default __webpack_public_path__ + "static/media/photo-12.8805adb2.jpeg";